import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';
import CommonTitle from '../../../common-components/common-title';

const team = {
    crewTitle: 'Вебпрактик',
    crewSubtitle: null,
    crewList: [
        {
            crewItemTitle: 'Ксения Жукова',
            crewItemSubtitle: 'руководитель группы performance-маркетинга',
        },
        {
            crewItemTitle: 'Светлана Комогорцева',
            crewItemSubtitle: 'менеджер проекта',
        },
        {
            crewItemTitle: 'Алина Костылева',
            crewItemSubtitle: 'PPC-специалист',
        },
    ],
};

function Team() {
    return (
        <FullWrapper>
            <CommonTitle>Команда</CommonTitle>
            <CrewContainer container={team} />
        </FullWrapper>
    );
}

export default Team;
